__turbopack_context__.v({
  "input": "PlpFiltersMake-module-scss-module__mQNO8W__input",
  "link": "PlpFiltersMake-module-scss-module__mQNO8W__link",
  "listSwitch": "PlpFiltersMake-module-scss-module__mQNO8W__listSwitch",
  "listTitle": "PlpFiltersMake-module-scss-module__mQNO8W__listTitle",
  "root": "PlpFiltersMake-module-scss-module__mQNO8W__root",
  "selectedOption": "PlpFiltersMake-module-scss-module__mQNO8W__selectedOption",
  "selectedOptionLabel": "PlpFiltersMake-module-scss-module__mQNO8W__selectedOptionLabel",
  "selectedOptionType": "PlpFiltersMake-module-scss-module__mQNO8W__selectedOptionType",
  "selectedOptions": "PlpFiltersMake-module-scss-module__mQNO8W__selectedOptions",
});
